<script>
import forminput from "../formcomponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";  
import menutranslations from "@/models/menutranslations";

export default {
  mixins: [apibtoast, apigeneric,menutranslations],
  props: ["DataId", "LanId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      AddEdit:null,
      FormData: {}, 
      languages: {},
      LinkTranslationsData: [],
    };
  },
  components: {
    Loader,
    forminput, 
    
  },
  watch: {
    DataId() { 
      
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("menutranslations", this.FormData).then((res) => {
            if (res) { 
              this.$emit("TableUpdate");  
            }
          });
        } else {
          this.Update("menutranslations", this.FormData).then((res) => {
            if (res) {
                
              this.$emit("TableUpdate");  
            }
          });
        }
      }
    },
    Get() {
      this.ActionsFilterGet({ Service: "menutranslations", Page: this.Page,
      Filter:"&Langid="+this.LanId+"&Menuid="+this.DataId}).then((res) => {
        
        if(res.Data.length > 0){
        this.FormData = res.Data[0]; 
        this.AddEdit = "Edit"
        }
        else{  
          this.FormData = this.menutranslationsData
          this.AddEdit = "Add"
          this.FormData.Menuid = this.DataId
          this.FormData.Langid = this.LanId 
          this.FormData.Websiteid = this.GettersWebsiteid 
        }
      });
    },
  
 
  },
};
</script>
<template>
  <Loader>  
      <Form @submit.prevent="onSubmit">   
        <div class="row"> 
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Title"
              :Value="FormData.Title"
              :v="$v.FormData.Title"
              @input="FormData.Title = $event"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Link"
              :Value="FormData.Link"
              :v="$v.FormData.Link"
              @input="FormData.Link = $event"
            />
          </div>  
        </div> 
        <button class="btn btn-primary" type="submit">
          {{ $t("links.AddEdit.Button") }}
        </button>
      </Form>
 
  </Loader>
</template>
